import {Button, Form, Input, AutoComplete, Popconfirm, Table} from 'antd'
import React, {useContext, useEffect, useRef, useState, useImperativeHandle} from 'react'
import {DeleteOutlined} from '@ant-design/icons'
import {JSONStringPath, removeDuplicate} from '../../../utils'
import {withTranslation} from 'react-i18next'

const EditableContext = React.createContext(null)


const EditableRow = ({index, ...props}) => {
  const [form] = Form.useForm()
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  )
}

const EditableCell = ({value, dataBody, title, editable, children, dataIndex, record, handleSave, dataSource, dataPathsList, ...restProps}) => {
  const [editing, setEditing] = useState(true)
  const inputRef = useRef(null)
  const form = useContext(EditableContext)
  useEffect(() => {
    // if(dataBody) {
    //   this.init(dataBody)
    // }
    // if(this.value.length) {
    //   setDataSource(this.value)
    // }
    // if(this.value.length) {
    //   setDataSource(this.value)
    // }

  }, ['record'])

  // const toggleEdit = () => {
  //   setEditing(!editing);
  //   form.setFieldsValue({
  //     [dataIndex]: record[dataIndex],
  //   });
  // };

  const save = async () => {
    try {
      const values = await form.validateFields()
      // toggleEdit();
      handleSave({...record, ...values})
    } catch (errInfo) {
      console.log('Save failed:', errInfo)
    }
  }
  let pathsList = []
  if (dataPathsList && dataPathsList.length) {
    pathsList = dataPathsList.map(item => { return {value: item.value}})
  }
  let childNode = children

  if (editable) {
    childNode = editing ? (
      <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.dataPath ? record.dataPath : ''}>
        <AutoComplete
          options={pathsList}
          placeholder="input here"
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onChange={save}
        />
      </Form.Item>
    ) : (
      <div className="editable-cell-value-wrap" style={{paddingRight: 24,}}>
        {children}
      </div>
    )
  }

  return <td {...restProps}>{childNode}</td>
}

const TargetDataForm = (props) => {
  const [dataSource, setDataSource] = useState([])
  const [count, setCount] = useState(0)
  const [dataPathsList, setDataPathsList] = useState([])
  const [tempDataPathsList, setTempDataPathsList] = useState([])
  const {dataBody, value, onChange, onRef, t} = props
  useImperativeHandle(onRef, () => ({
    init,
  }))
  useEffect(() => {
    if (value.length) {
      setDataSource(addRowKey(value))
    }

  }, [value])

  useEffect(() => {
    if (dataBody) {
      init(dataBody)
    }
  }, [dataBody])
  const rowKey = (item) => {
    return item.index
  }

  const addRowKey = (list) => {
    if (!list) {
      return null
    }
    const newList = []
    list.forEach((item, i) => {
      const index = `${i + 1}`
      const newItem = {
        ...item,
        index: index
      }
      newList.push(newItem)
    })
    return newList
  }

  const handleDelete = (record, key) => {
    // const newData = dataSource.filter((item) => item.index !== key);
    dataSource.splice(key, 1)
    setDataSource([...dataSource])
    onChange([...dataSource])
  }

  const init = (json) => {
    let tList = []
    try {
      tList = JSONStringPath(JSON.parse(json || '{}')).tempDataPathsList
      setTempDataPathsList(tList)
    } catch (e) {
    }
    if (tList.length > 0) {
      setDataPathsList(removeDuplicate(tList))
    }
  }
  useEffect(() => {
    if (dataSource.length === 0 && tempDataPathsList.length) {
      handleAdd()
    }
  }, [tempDataPathsList])

  const defaultColumns = [
    {
      title: t(`apiManagement.dataPath`),
      dataIndex: 'dataPath',
      width: '90%',
      editable: true,
    },
    {
      title: t(`general.action`),
      dataIndex: 'action',
      align: 'center',
      render: (_, record, index) =>
        dataSource.length >= 1 ? (
          <Popconfirm title={t(`general.sureToDelete`)} onConfirm={() => handleDelete(record, index)}>
            <a><DeleteOutlined/></a>
          </Popconfirm>
        ) : null,
    },
  ]

  const handleAdd = () => {
    const data = JSON.parse(JSON.stringify(dataSource))
    let list = tempDataPathsList

    let defaultDataPath = ''
    if (list.length > 0) {
      defaultDataPath = list.find(item => item.isArr === true)
    }
    const newData = {
      key: count,
      index: dataSource.length + 1,
      // index: dataSource.length ? Number(dataSource[dataSource.length - 1].index)+1 : 0,
      dataPath: defaultDataPath ? defaultDataPath.value : '',
      isOpenDataPath: false
    }

    data.push(newData)
    setDataSource([...addRowKey(data)])
    if (defaultDataPath) {
      onChange([...data])
      // handleSave(newData)
    }
    setCount(count + 1)
    // setCount(dataSource.length + 1);
  }
  const getObj = (arr, row) => {
    // let newData = [...detail.children];
    arr.forEach(function (item, index) {
      // if(item.key===row.key){
      if (item.index === row.index) {
        arr.splice(index, 1, {...item, ...row})
      } else if (item.children && item.children.length > 0) {
        getObj(item.children, row)
      }
    })
    return arr
  }
  const handleSave = (row) => {
    // let newData = getObj(dataSource, row)
    // onChange(newData)
    // console.log('newData', [...newData])
    // setDataSource([...newData]);
    //
    const newData = [...dataSource]
    const index = newData.findIndex((item) => row.index === item.index)
    const item = newData[index]
    newData.splice(index, 1, {...item, ...row})
    onChange(newData)
    setDataSource(newData)
  }

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  }
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col
    }

    return {
      ...col,
      onCell: (record) => ({
        dataBody,
        record,
        dataSource,
        dataPathsList,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    }
  })
  return (
    <div>
      <Button onClick={handleAdd} type="primary" style={{marginBottom: 16,}}> {t(`general.add`)} </Button>
      <Table
        components={components}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        rowKey={rowKey}
      />
    </div>
  )
}

export default withTranslation()(TargetDataForm)
